import React from 'react'
import { EntityDetailView } from '@/components/entity/EntityDetailView'

export function DeveloperDetail() {
  return <EntityDetailView entityType="developer" />
}
